<template>
  <div
    class="table-shell tw-overflow-auto tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-200/50">
    <table class="tw-w-full tw-border-collapse tw-text-left tw-text-sm tw-text-slate-800">
      <thead class="table-head">
        <tr>
          <th v-if="isExportSelectionMode"
            class="tw-whitespace-nowrap tw-px-2 tw-pr-0 -tw-mr-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer tw-relative">
            <input type="checkbox" class="tw-inline-flex tw-pointer-events-auto" :checked="selectionApi?.allSelected"
              @click.stop="selectionApi?.toggleAll()" />
            &nbsp;
          </th>
          <th
            class="tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer tw-relative"
            @click="updateSortBy('container')">
            <span class="tw-h-[22px] tw-w-[20px] tw-cursor-pointer" @click.prevent.stop="updateSortBy('id')">
              <font-awesome-icon
                :icon="sortBy === 'id' ? (sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down'"
                class="tw-h-3.5 tw-w-3.5 tw-transition-transform"
                :class="sortBy === 'id' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'" />
              <font-awesome-icon icon="clock" class="tw-h-[10px] tw-w-[10px] tw-z-10 tw-text-slate-400" />
            </span>
            <span class="tw-inline-flex tw-items-center tw-gap-2 tw-ml-3">
              <label class="tw-cursor-pointer" v-if="isExportSelectionMode" @click.stop.prevent="toggleExportColumn('container')">
                <input type="checkbox" class="tw-inline-flex tw-pointer-events-auto"
                  :checked="isExportColumnSelected('container')" />
                Container
              </label>
              <span v-else>Container</span>
              <font-awesome-icon
                :icon="sortBy === 'container' ? (sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down'"
                class="tw-h-3.5 tw-w-3.5 tw-transition-transform"
                :class="sortBy === 'container' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'" />
              
            </span>
          </th>

          <th scope="col" class="tw-w-14 tw-px-2 tw-py-3 tw-text-center tw-font-semibold tw-text-slate-700"
            aria-label="Notes">
            <font-awesome-icon :icon="['fas', 'sticky-note']" class="tw-h-3.5 tw-w-3.5 tw-text-slate-400"
              aria-hidden="true" />
          </th>

          <th class="tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer"
            @click="updateSortBy('bl')">
            <span class="tw-inline-flex tw-items-center tw-gap-2">
              <label class="tw-cursor-pointer" v-if="isExportSelectionMode" @click.stop.prevent="toggleExportColumn('bl')">
                <input type="checkbox" class="tw-inline-flex tw-pointer-events-auto"
                  :checked="isExportColumnSelected('bl')" />
                B/L
              </label>
              <span v-else>B/L</span>
              
              <font-awesome-icon
                :icon="sortBy === 'bl' ? (sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down'"
                class="tw-h-3.5 tw-w-3.5 tw-transition-transform"
                :class="sortBy === 'bl' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'" />
            </span>
          </th>

          <th v-if="typeOfAppointmentsShowing === 'terminal'"
            class="tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer"
            @click="updateSortBy('terminalAppt')">
            <span class="tw-inline-flex tw-items-center tw-gap-2">
              <label class="tw-cursor-pointer" v-if="isExportSelectionMode" @click.stop.prevent="toggleExportColumn('terminalAppt')">
                <input type="checkbox" class="tw-inline-flex tw-pointer-events-auto"
                  :checked="isExportColumnSelected('terminalAppt')" />
                Terminal Appointment
              </label>
              <span v-else>Terminal Appointment</span>
              
              <font-awesome-icon
                :icon="sortBy === 'terminalAppt' ? (sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down'"
                class="tw-h-3.5 tw-w-3.5 tw-transition-transform"
                :class="sortBy === 'terminalAppt' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'" />
            </span>
          </th>

          <th v-if="typeOfAppointmentsShowing === 'delivery'"
            class="tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer"
            @click="updateSortBy('deliveryAppt')">
            <span class="tw-inline-flex tw-items-center tw-gap-2">
              <label class="tw-cursor-pointer" v-if="isExportSelectionMode" @click.stop.prevent="toggleExportColumn('deliveryAppt')">
                <input type="checkbox" class="tw-inline-flex tw-pointer-events-auto"
                  :checked="isExportColumnSelected('deliveryAppt')" />
                Delivery Appointment
              </label>
              <span v-else>Delivery Appointment</span>
              
              <font-awesome-icon
                :icon="sortBy === 'deliveryAppt' ? (sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down'"
                class="tw-h-3.5 tw-w-3.5 tw-transition-transform"
                :class="sortBy === 'deliveryAppt' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'" />
            </span>
          </th>

          <th class="tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer"
            @click="updateSortBy('eta')">
            <span class="tw-inline-flex tw-items-center tw-gap-2">
              <label class="tw-cursor-pointer" v-if="isExportSelectionMode" @click.stop.prevent="toggleExportColumn('eta')">
                <input type="checkbox" class="tw-inline-flex tw-pointer-events-auto"
                  :checked="isExportColumnSelected('eta')" />
                ETA/LFD
              </label>
              <span v-else>ETA/LFD</span>
              
              <font-awesome-icon
                :icon="sortBy === 'eta' ? (sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down'"
                class="tw-h-3.5 tw-w-3.5 tw-transition-transform"
                :class="sortBy === 'eta' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'" />
            </span>
          </th>

          <th v-if="!typeOfAppointmentsShowing"
            class="tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer"
            @click="updateSortBy('vessel')">
            <span class="tw-inline-flex tw-items-center tw-gap-2">
              <label class="tw-cursor-pointer" v-if="isExportSelectionMode" @click.stop.prevent="toggleExportColumn('vessel')">
                <input type="checkbox" class="tw-inline-flex tw-pointer-events-auto"
                  :checked="isExportColumnSelected('vessel')" />
                Vessel Name
              </label>
              <span v-else>Vessel Name</span>
              <font-awesome-icon
                :icon="sortBy === 'vessel' ? (sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down'"
                class="tw-h-3.5 tw-w-3.5 tw-transition-transform"
                :class="sortBy === 'vessel' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'" />
            </span>
          </th>

          <th class="tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer"
            @click=" updateSortBy('yard')">
            <span class="tw-inline-flex tw-items-center tw-gap-2">
              <label class="tw-cursor-pointer" v-if="isExportSelectionMode" @click.stop.prevent="toggleExportColumn('yardStatus')">
                <input type="checkbox" class="tw-inline-flex tw-pointer-events-auto"
                  :checked="isExportColumnSelected('yardStatus')" />
                Yard Status
              </label>
              <span v-else>Yard Status</span>
              <font-awesome-icon
                :icon="sortBy === 'yard' ? (sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down'"
                class="tw-h-3.5 tw-w-3.5 tw-transition-transform"
                :class="sortBy === 'yard' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'" />
            </span>
          </th>

          <th class="tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer"
            @click="updateSortBy('terminal')">
            <span class="tw-inline-flex tw-items-center tw-gap-2">
              <label class="tw-cursor-pointer" v-if="isExportSelectionMode" @click.stop.prevent="toggleExportColumn('terminal')">
                <input type="checkbox" class="tw-inline-flex tw-pointer-events-auto"
                  :checked="isExportColumnSelected('terminal')" />
                Terminal
              </label>
              <span v-else>Terminal</span>
              <font-awesome-icon
                :icon="sortBy === 'terminal' ? (sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down'"
                class="tw-h-3.5 tw-w-3.5 tw-transition-transform"
                :class="sortBy === 'terminal' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'" />
            </span>
          </th>

          <th class="tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700">
            <label class="tw-cursor-pointer" v-if="isExportSelectionMode" @click.stop.prevent="toggleExportColumn('sizeType')">
              <input type="checkbox" class="tw-inline-flex tw-pointer-events-auto"
                :checked="isExportColumnSelected('sizeType')" />
              Type
            </label>
            <span v-else>Type</span>
          </th>

          <th v-if="!isHideCustomerInfo"
            class="tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer"
            @click="updateSortBy('customer')">
            <span class="tw-inline-flex tw-items-center tw-gap-2">
              <label class="tw-cursor-pointer" v-if="isExportSelectionMode" @click.stop.prevent="toggleExportColumn('customer')">
                <input type="checkbox" class="tw-inline-flex tw-pointer-events-auto"
                  :checked="isExportColumnSelected('customer')" />
                Customer
              </label>
              <span v-else>Customer</span>
              <font-awesome-icon
                :icon="sortBy === 'customer' ? (sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down'"
                class="tw-h-3.5 tw-w-3.5 tw-transition-transform"
                :class="sortBy === 'customer' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'" />
            </span>
          </th>

          <th v-if="!typeOfAppointmentsShowing"
            class="tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer"
            @click="updateSortBy('lastTerminalScrapeUpdate')">
            <span class="tw-inline-flex tw-items-center tw-gap-2">
              <label class="tw-cursor-pointer" v-if="isExportSelectionMode" @click.stop.prevent="toggleExportColumn('lastTerminalScrapeUpdate')">
                <input type="checkbox" class="tw-inline-flex tw-pointer-events-auto"
                  :checked="isExportColumnSelected('lastTerminalScrapeUpdate')" />
                Scrape Update
              </label>
              <span v-else>Scrape Update</span>
              <font-awesome-icon
                :icon="sortBy === 'lastTerminalScrapeUpdate' ? (sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down'"
                class="tw-h-3.5 tw-w-3.5 tw-transition-transform"
                :class="sortBy === 'lastTerminalScrapeUpdate' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'" />
            </span>
          </th>

          <th v-if="!typeOfAppointmentsShowing"
            class="tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer"
            @click="updateSortBy('lastTerminalScrapeFetch')">
            <span class="tw-inline-flex tw-items-center tw-gap-2">
              <label class="tw-cursor-pointer" v-if="isExportSelectionMode" @click.stop.prevent="toggleExportColumn('lastTerminalScrapeFetch')">
                <input type="checkbox" class="tw-inline-flex tw-pointer-events-auto"
                  :checked="isExportColumnSelected('lastTerminalScrapeFetch')" />
                Last Scrape
              </label>
              <span v-else>Last Scrape</span>
              <font-awesome-icon
                :icon="sortBy === 'lastTerminalScrapeFetch' ? (sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down'"
                class="tw-h-3.5 tw-w-3.5 tw-transition-transform"
                :class="sortBy === 'lastTerminalScrapeFetch' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'" />
            </span>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(container, containerIndex) in filteredContainers" :key="container.id" class="table-row" :class="[
          getIsLastOpenedListItem(lastOpenedContainerId, container.id)
            ? 'tw-bg-amber-100/70'
            : (containerIndex % 2 === 0 ? 'tw-bg-white/25' : 'tw-bg-sky-50/60'),
          'hover:tw-bg-slate-900/5',
        ]" v-on:click="isExportSelectionMode ? toggleExportContainer(container.id) : selectContainer(container.id)">
          <td v-if="isExportSelectionMode"
            class="tw-whitespace-nowrap tw-px-2 tw-pr-0 -tw-mr-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer">
            <input type="checkbox" class="tw-inline-flex tw-pointer-events-auto"
              :checked="isExportContainerIdSelected(container.id)" @click.stop="toggleExportContainer(container.id)" />
            &nbsp;
          </td>
          <td class="tw-px-4 tw-py-4 tw-align-top"
            :class="[isExportColumnSelectedForContainerId('container', container.id) ? 'tw-bg-emerald-100' : '']">
            <div class="tw-flex tw-items-center">
              <CopyButton :value="container.containerId" mode="wrap-content" icon-position="left"
                title="Copy container ID" aria-label="Copy container ID to clipboard"
                class="tw-font-semibold tw-text-slate-900 tw-font-bold">
                {{ container.containerId }}
              </CopyButton>
              <span v-if="container.isCancelled"
                class="tw-ml-2 tw-inline-flex tw-items-center tw-rounded-md tw-bg-rose-50 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-rose-800 tw-ring-1 tw-ring-inset tw-ring-rose-600/20"
                :title="container.cancelledReason || 'Cancelled on order'">
                Cancelled
              </span>
              <span v-if="container && container.order" class="tw-ml-2"
                v-tippy="{ content: `Container part of Order ${container.order.id}`, placement: 'top-end' }">
                <font-awesome-icon icon="tag" class="tw-h-3.5 tw-w-3.5"
                  :class="container.order && container.order.status === 'In Progress' ? 'tw-text-emerald-600' : 'tw-text-slate-400'" />
              </span>

              <span :content="`Terminal Appointment: ${formatAppointmentDatetime(
                container.terminalAppointmentDate,
                container.terminalAppointmentHasTime,
              )}`" v-tippy="{ placement: 'bottom' }">
                <img :src="ShipIcon" alt="Terminal Appointment" class="tw-m-1 tw-h-5 tw-w-5"
                  v-if="container.terminalAppointmentDate" />
              </span>
              <span :content="`Delivery Appointment: ${formatAppointmentDatetime(
                container.deliveryAppointmentDate,
                container.deliveryAppointmentHasTime,
              )}`" v-tippy="{ placement: 'bottom' }">
                <img :src="DeliveryIcon" alt="Terminal Appointment" class="tw-m-1 tw-h-5 tw-w-5 tw-font-slate-400"
                  v-if="container.deliveryAppointmentDate" />
              </span>
            </div>
          </td>
          <td class="notes-cell tw-w-14 tw-px-2 tw-py-4 tw-align-middle tw-text-center" @click.stop>
            <button type="button"
              class="tw-relative tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-border tw-p-1.5 tw-text-xs tw-font-semibold tw-transition"
              :class="containerNotesCount(container) > 0
                ? 'tw-border-emerald-300 tw-bg-emerald-50 tw-text-emerald-700 hover:tw-bg-emerald-100'
                : 'tw-border-slate-300 tw-bg-slate-100 tw-text-slate-900 hover:tw-bg-slate-200'"
              :aria-label="`Container notes, ${containerNotesCount(container)}`" v-tippy="containerNotesCount(container) > 0
                ? `View ${containerNotesCount(container)} note${containerNotesCount(container) > 1 ? 's' : ''}`
                : 'Add container notes'" @click.stop="openContainerNotes(container)">
              <font-awesome-icon :icon="['fas', 'sticky-note']" />
              <span v-if="containerNotesCount(container) > 0"
                class="tw-absolute tw--right-1.5 tw--top-1.5 tw-inline-flex tw-h-5 tw-min-w-[1.25rem] tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-emerald-600 tw-bg-emerald-600 tw-px-1 tw-text-[10px] tw-font-bold tw-text-white">
                {{ containerNotesCount(container) }}
              </span>
            </button>
          </td>
          <td class="tw-px-4 tw-py-4 tw-align-top tw-text-slate-700" v-if="container.billOfLading"
            :class="[isExportColumnSelectedForContainerId('bl', container.id) ? 'tw-bg-emerald-100' : '']">
            <CopyButton :value="container.billOfLading.billOfLadingNumber" mode="wrap-content" title="Copy B/L number"
              aria-label="Copy B/L number to clipboard">
              {{ container.billOfLading.billOfLadingNumber }}
            </CopyButton>
          </td>
          <td class="tw-px-4 tw-py-4 tw-align-top tw-text-slate-500" v-else
            :class="[isExportColumnSelectedForContainerId('bl', container.id) ? 'tw-bg-emerald-100' : '']">N/A</td>

          <td v-if="typeOfAppointmentsShowing === 'delivery'"
            class="tw-px-4 tw-py-4 tw-align-top tw-text-left tw-text-slate-700"
            :class="[isExportColumnSelectedForContainerId('deliveryAppt', container.id) ? 'tw-bg-emerald-100' : '']">
            {{ formatAppointmentDatetime(container.deliveryAppointmentDate, container.deliveryAppointmentHasTime) }}
          </td>
          <td v-if="typeOfAppointmentsShowing === 'terminal'"
            class="tw-px-4 tw-py-4 tw-align-top tw-text-left tw-text-slate-700"
            :class="[isExportColumnSelectedForContainerId('terminalAppt', container.id) ? 'tw-bg-emerald-100' : '']">
            {{ formatAppointmentDatetime(container.terminalAppointmentDate, container.terminalAppointmentHasTime) }}
          </td>
          <td v-if="getIsEtaShownForYardStatus(container.yardStatus)" class="tw-px-4 tw-py-4 tw-align-top"
            :class="[isExportColumnSelectedForContainerId('eta', container.id) ? 'tw-bg-emerald-100' : '']">
            <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
              <span class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500">ETA</span>
              <span class="tw-text-sm tw-font-semibold tw-text-slate-900 tw-whitespace-nowrap">{{ container.eta
              }}</span>
            </div>
          </td>
          <td v-else-if="container.lfd && container.lfd.length > 2" class="tw-px-4 tw-py-4 tw-align-top"
            :class="[isExportColumnSelectedForContainerId('eta', container.id) ? 'tw-bg-emerald-100' : '']">
            <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
              <span
                class="tw-inline-flex tw-items-center tw-rounded-full tw-bg-amber-100 tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wide tw-text-amber-800">LFD</span>
              <span
                class="tw-inline-flex tw-items-center tw-rounded-full tw-bg-amber-100 tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-amber-800 tw-whitespace-nowrap">{{
                  container.lfd }}</span>
            </div>
          </td>
          <td class="tw-px-4 tw-py-4 tw-align-top"
            :class="[isExportColumnSelectedForContainerId('eta', container.id) ? 'tw-bg-emerald-100' : '']" v-else>
            <span
              class="tw-inline-flex tw-items-center tw-rounded-full tw-bg-amber-100 tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-amber-800">No LFD</span>
          </td>
          <td v-if="!typeOfAppointmentsShowing" class="tw-px-4 tw-py-4 tw-align-top tw-text-slate-700"
            :class="[isExportColumnSelectedForContainerId('vessel', container.id) ? 'tw-bg-emerald-100' : '']">
            <div v-if="container.vessel" class="tw-truncate">{{ container.vessel.name }}</div>
            <div v-else class="tw-text-slate-500">Vessel Not Available</div>
          </td>
          <td class="tw-px-4 tw-py-4 tw-align-top" :title="container.isCancelled
            ? (container.cancelledReason || 'Cancelled on order')
            : (container.yardStatusDescription.split('\n')[1] &&
              container.yardStatusDescription.split('\n')[1] != '\xa0'
              ? `${container.yardStatusDescription.split('\n')[1]}`
              : '')
            " :class="[isExportColumnSelectedForContainerId('yardStatus', container.id) ? 'tw-bg-emerald-100' : '']">
            <div v-if="container.isCancelled" class="tw-text-sm tw-text-rose-800">
              Cancelled <span v-if="container.cancelledReason"> — {{ container.cancelledReason }}</span>
            </div>
            <YardStatusLabel v-else :container="container" :enableStale="false"></YardStatusLabel>
          </td>
          <td v-if="container.terminal.includes('Expected')" class="tw-px-4 tw-py-4 tw-align-top tw-text-slate-700"
            :class="[isExportColumnSelectedForContainerId('terminal', container.id) ? 'tw-bg-emerald-100' : terminalCellClass(container.terminal)]"
            title="Container not yet found, system will try this terminal at next update">
            <div class="tw-inline-flex tw-items-center tw-gap-2">
              <font-awesome-icon icon="triangle-exclamation" class="tw-h-4 tw-w-4 tw-text-amber-600" />
              <span>{{ container.terminal.split('(')[0] }}</span>
            </div>
          </td>
          <td v-else class="tw-px-4 tw-py-4 tw-align-top tw-text-slate-700"
            :class="[isExportColumnSelectedForContainerId('terminal', container.id) ? 'tw-bg-emerald-100' : terminalCellClass(container.terminal)]">
            {{ container.terminal }}
          </td>
          <td class="tw-relative tw-pl-3 tw-pr-0 tw-py-4 tw-align-top tw-text-slate-700"
            :class="[isExportColumnSelectedForContainerId('sizeType', container.id) ? 'tw-bg-emerald-100' : '']">
            {{ container.sizeType }}
            <template v-if="getIsReeferSizeType(container.sizeType)">
              <span v-if="!container.isGensetRequired && !getHasGensetTemperatureOrVents(container)" class="tw-inline-flex" style=""
                v-tippy="{ content: 'Reefer', placement: 'top' }">
                <font-awesome-icon icon="snowflake" class="tw-h-3 tw-w-3 tw-text-sky-500" />
              </span>
              <span v-if="container.isGensetRequired" class="tw-absolute tw-right-1 tw-top-3"
                v-tippy="{ content: container.isGensetApprovedByShipline === true ? 'Genset needed, approved' : 'Genset needed, NOT approved yet', placement: 'top' }">
                <font-awesome-icon icon="bolt-lightning" class="tw-h-3 tw-w-3"
                  :class="container.isGensetApprovedByShipline === true ? 'tw-text-emerald-400' : 'tw-text-slate-500'" />
              </span>
              <span v-if="getHasGensetTemperatureOrVents(container)" class="tw-absolute tw-right-1 tw-top-7"
                v-tippy="{ content: getGensetTemperatureAndVentsTooltip(container), placement: 'bottom' }">
                <font-awesome-icon icon="temperature-high" class="tw-h-3 tw-w-3 tw-text-slate-500" />
              </span>
            </template>
          </td>
          <td v-if="!isHideCustomerInfo" class="tw-px-4 tw-py-4 tw-align-top"
            :class="[container.customer ? 'tw-text-slate-700' : 'tw-text-slate-500', isExportColumnSelectedForContainerId('customer', container.id) ? 'tw-bg-emerald-100' : '']">
            {{
              container.customer ? (
                container.customer.displayName
                  ? container.customer.displayName
                  : container.customer.name
              ) : 'N/A'
            }}
          </td>
          <td v-if="!typeOfAppointmentsShowing" class="tw-px-4 tw-py-4 tw-align-top tw-text-slate-700"
            :class="[isExportColumnSelectedForContainerId('lastTerminalScrapeUpdate', container.id) ? 'tw-bg-emerald-100' : '']">
            <span class="tw-whitespace-nowrap">{{ formatScraperUpdate(container.lastScraperUpdate) }}</span>
          </td>
          <td v-if="!typeOfAppointmentsShowing" class="tw-px-4 tw-py-4 tw-align-top tw-text-slate-700"
            :class="[isExportColumnSelectedForContainerId('lastTerminalScrapeFetch', container.id) ? 'tw-bg-emerald-100' : '']">
            <div class="tw-flex tw-items-center tw-gap-2">
              <span class="tw-whitespace-nowrap">{{ formatScraperUpdate(container.lastScraperFetch) }}</span>
              <button v-if="!loading.includes(container.id)" v-on:click="rescrapeContainerFromTerminal(container.id)"
                v-on:click.stop type="button" title="Update Container"
                class="tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-text-slate-600 hover:tw-bg-white">
                <font-awesome-icon icon="rotate-right" class="tw-h-3.5 tw-w-3.5" />
              </button>
              <span v-else class="tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center" aria-label="Updating">
                <font-awesome-icon icon="circle-notch" spin class="tw-h-4 tw-w-4 tw-text-slate-500" />
              </span>
            </div>
            <span v-if="getIsContainerAddedSincePageLoad(container.containerId)"
              class="tw-mr-2 tw-inline-flex tw-items-center tw-rounded-full tw-bg-indigo-600 tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-white">New</span>
            <span v-if="getIsContainerChangedSincePageLoad(container.containerId)"
              class="tw-mr-2 tw-inline-flex tw-items-center tw-rounded-full tw-bg-amber-600 tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-white">Changed</span>
          </td>
        </tr>
      </tbody>
    </table>

    <Modal :isOpen="isExportSelectionModalOpen" @update:isOpen="$emit('update:isExportSelectionModalOpen', $event)"
      modalId="tracking-export-selection-modal" maxWidth="7xl" ariaLabel="Container details">
      <template #title>
        Export Selection
      </template>
      <template #content>

        <div class="tw-flex tw-h-full tw-min-h-0 tw-flex-col tw-gap-3">
          <div class="tw-shrink-0">
            <button
              class="tw-gap-2 tw-px-2 tw-py-2 tw-backdrop-blur tw-border tw-rounded-xl tw-shadow-sm tw-transition-all tw-text-sm tw-font-medium"
              :class="[exportSelectionFormat === 'csv' ? 'tw-bg-slate-600 tw-text-white' : 'tw-bg-slate-200 tw-text-black']"
              @click="$emit('update:exportSelectionFormat', 'csv')">CSV</button>
            &nbsp;
            <button
              class="tw-gap-2 tw-px-2 tw-py-2 tw-backdrop-blur tw-border tw-rounded-xl tw-shadow-sm tw-transition-all tw-text-sm tw-font-medium"
              :class="[exportSelectionFormat === 'text' ? 'tw-bg-slate-600 tw-text-white' : 'tw-bg-slate-200 tw-text-black']"
              @click="$emit('update:exportSelectionFormat', 'text')">Text</button>
            &nbsp;
            <button
              class="tw-px-2 tw-py-2 tw-backdrop-blur tw-border tw-rounded-xl tw-shadow-sm tw-transition-all tw-text-sm tw-font-medium"
              :class="[exportSelectionFormat === 'html' ? 'tw-bg-slate-600 tw-text-white' : 'tw-bg-slate-200 tw-text-black']"
              @click="$emit('update:exportSelectionFormat', 'html')">HTML</button>
            &nbsp;

            <label><input type="checkbox" :checked="isExportReportShowHeader"
                @click="isExportReportShowHeader = !isExportReportShowHeader"> Show header</label>
          </div>

          <div class="tw-min-h-0 tw-flex-1 tw-overflow-auto" style="max-height: 300px;">
            <div v-if="!selectionApi.count">No rows selected</div>
            <div v-else ref="exportReportElementRef">
              <div class="tw-flex tw-gap-1 tw-my-1">
                <button class="tw-bg-slate-100 tw-text-black tw-px-4 tw-py-2 tw-rounded tw-rounded-xl"
                  @click="copyExportReport()">
                  Copy
                  <font-awesome-icon icon="copy" class="tw-h-5 tw-w-5 tw-z-10 tw-text-slate-800" />
                </button>
                &nbsp;
                <button class="tw-bg-slate-100 tw-text-black tw-px-4 tw-py-2 tw-rounded tw-rounded-xl"
                  @click="downloadExportReport()">
                  Download
                  <font-awesome-icon icon="download" class="tw-h-5 tw-w-5 tw-z-10 tw-text-slate-800" />
                </button>
              </div>

              <div v-if="exportSelectionFormat === 'csv' || exportSelectionFormat === 'text'" style="white-space: pre;">{{ exportReportString }}</div>
              <div v-else-if="exportSelectionFormat === 'html'" v-html="exportReportString"></div>
              <div v-else>No export format selected</div>
            </div>


          </div>
        </div>
      </template>

    </Modal>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import ShipIcon from '@/assets/noun-ship-5576265.svg';
import DeliveryIcon from '@/assets/noun-delivery-8353279.svg';
import HourGlass from '@carbon/icons-vue/es/hourglass/24';
import EventSchedule from '@carbon/icons-vue/es/event--schedule/24';
import StartContainerRescrapeFromTerminal from '../../gql/StartContainerRescrapeFromTerminal.gql';
import YardStatusLabel from '../UI/YardStatusLabel.vue';
import CopyButton from '../core/CopyButton.vue';
import { datetimeFormatMixin } from '../../utils/date';
import { getIsReeferSizeType, getHasGensetTemperatureOrVents, getGensetTemperatureAndVentsTooltip, getIsEtaShownForYardStatus } from '../../utils/container';
import GetContainerStatus from '@/gql/containers/GetContainerStatus.gql';
import Modal from '@/components/core/Modal/Modal.vue';
import { getIsLastOpenedListItem } from '@/utils/savedLastOpenedListItem';

import { pushToast } from '@/lib/toast';

export default defineComponent({
  name: 'ContainerTable',
  setup() {
    const exportReportElementRef = ref(null);
    return { exportReportElementRef };
  },
  components: {
    YardStatusLabel,
    CopyButton,
    HourGlass,
    EventSchedule,
    Modal,
  },
  props: {
    containers: {
      required: true,
      type: Array,
    },
    isHideCustomerInfo: {
      default: false,
      type: Boolean,
    },
    containerNumbersAddedSincePageLoad: {
      required: false,
      default: () => [],
    },
    containerNumbersChangedSincePageLoad: {
      required: false,
      default: () => [],
    },
    lastOpenedContainerId: {
      type: String,
      default: null,
    },
    sortBy: {
      required: false,
    },
    sortOrder: {
      required: false,
      default: 'DESC',
    },
    typeOfAppointmentsShowing: {
      default: "",
      type: String,
    },
    isExportSelectionMode: {
      default: false,
    },
    isExportSelectionModalOpen: {
      default: false,
    },
    exportSelectionColumnMode: {
      default: 'multiple',
    },
    exportSelectionFormat: {
      default: 'csv', // or html or text
    },
    selectionApi: {
      default: null,
    },
  },
  emits: ['update:isExportSelectionModalOpen', 'update:exportSelectionFormat', 'selectContainer', 'archiveContainer', 'updateSortBy', 'openContainerNotes', 'refreshContainers'],
  data() {
    return {
      selectedContainer: -1,
      // ids of containers with a single-container rescrape in progress
      loading: [],
      refreshContainersEmitTimeout: null as ReturnType<typeof setTimeout> | null,
      rowContainers: [],
      ShipIcon,
      DeliveryIcon,
      selectedColumns: {
        container: true,
        bl: true,
        eta: true,
        vessel: true,
        yardStatus: true,
        terminal: true,
        terminalAppt: false,
        deliveryAppt: false,
        sizeType: true,
        customer: true,
        lastTerminalScrapeUpdate: false,
        lastTerminalScrapeFetch: false,
      },
      exportReportString: '',
      isExportReportShowHeader: true,
      hasSelectedColumnsInitialized: false,
    };
  },
  mixins: [datetimeFormatMixin],
  computed: {
    filteredContainers(): any[] {
      // the parent's NEW filter is applied server-side (filterContainerIds), so every row is shown
      return (this as any).rowContainers;
    },
    filteredIdxs(): number[] {
      return (this as any).containers.map((cntr: any) => cntr.index);
    },
  },
  watch: {
    containers: {
      immediate: true,
      handler(newVal: any[]) {
        const vm = (this as any);
        vm.rowContainers = (newVal || []).map((cntr: any) => cntr.container);
      },
    },
    isExportSelectionMode: {
      handler() {
        if (!this.hasSelectedColumnsInitialized) {
          this.selectedColumns = this.getExportDefaultColumns();
          this.hasSelectedColumnsInitialized = true;
        }
        this.generateExportReport();
      },
      immediate: true,
    },
    exportSelectionFormat: {
      handler() {
        this.generateExportReport();
      },
      immediate: true,
    },
    isExportReportShowHeader: {
      handler() {
        this.generateExportReport();
      },
      immediate: true,
    },
    exportSelectionColumnMode: {
      handler(v) {
        if (v === 'single') {
          this.setFirstSelectedColumnOnly();
        } else {
          this.selectedColumns = this.getExportDefaultColumns();
        }

        this.generateExportReport();
      },
      immediate: true,
    },
    typeOfAppointmentsShowing: {
      handler() {
        this.selectedColumns = this.getExportDefaultColumns();
      },
      immediate: true,
    },
    isHideCustomerInfo: {
      handler() {
        let isApplyCurrentValues = true;
        this.selectedColumns = this.getExportDefaultColumns();
      },
      immediate: true,
    },
    isExportSelectionModalOpen: {
      handler() {
        this.generateExportReport();
      },
      immediate: true,
    },
  },
  beforeUnmount() {
    const vm = (this as any);
    if (vm.refreshContainersEmitTimeout) {
      clearTimeout(vm.refreshContainersEmitTimeout);
    }
  },
  methods: {
    getIsLastOpenedListItem,
    getIsReeferSizeType,
    getHasGensetTemperatureOrVents,
    getGensetTemperatureAndVentsTooltip,
    getIsEtaShownForYardStatus,
    getToastScrapeOutcomeMessageAndVariant(outcome: string | null | undefined): {
      message: string;
      variant: 'success' | 'warning' | 'error';
    } {
      switch (outcome) {
        case 'success':
          return { message: 'Container updated successfully', variant: 'success' };
        case 'not_found':
          return {
            message: 'Container not found at terminal',
            variant: 'error',
          };
        case 'failed':
          return {
            message: 'Terminal update failed',
            variant: 'error',
          };
        case 'quota_reached':
          return {
            message: 'Terminal monthly scrape quota reached',
            variant: 'error',
          };
        case 'no_change':
          return { message: 'No new data for container', variant: 'warning' };
        default:
          return {
            message: 'No new data for container',
            variant: 'warning',
          };
      }
    },
    getIsContainerAddedSincePageLoad(containerNumber: string): boolean {
      const vm: any = this as any;
      return (vm.containerNumbersAddedSincePageLoad || []).includes(containerNumber);
    },
    getIsContainerChangedSincePageLoad(containerNumber: string): boolean {
      const vm: any = this as any;
      return (vm.containerNumbersChangedSincePageLoad || []).includes(containerNumber);
    },
    appointmentLabel(container): string {
      if (
        container.terminalAppointmentDate &&
        container.deliveryAppointmentDate
      ) {
        return 'Container has delivery and terminal appointments';
      } else if (container.terminalAppointmentDate) {
        return 'Container has terminal appointments';
      } else if (container.deliveryAppointmentDate) {
        return 'Container has delivery appointments';
      }

      return '';
    },
    selectContainer(containerIndex: number) {
      (this as any).$emit('selectContainer', containerIndex);
    },
    /**
     * Ask the parent to refetch the list once rescrapes finish. Rescrapes finishing within
     * 2 seconds of each other produce a single refreshContainers, 2 seconds after the last one.
     */
    scheduleRefreshContainersEmit() {
      const vm = (this as any);
      if (vm.refreshContainersEmitTimeout) {
        clearTimeout(vm.refreshContainersEmitTimeout);
      }
      vm.refreshContainersEmitTimeout = setTimeout(() => {
        vm.refreshContainersEmitTimeout = null;
        vm.$emit('refreshContainers');
      }, 2000);
    },
    rescrapeContainerFromTerminal(containerDbId: any) {
      const vm = (this as any);

      // keyed by container id (not row index): the filtered rows and the row order can change while the rescrape runs
      const containerObj = vm.rowContainers.find((cntr: any) => cntr.id === containerDbId);
      if (!containerObj) {
        return;
      }
      const initialTime = containerObj.lastScraperFetch;

      if (!vm.loading.includes(containerDbId)) {
        vm.loading.push(containerDbId);
      }
      console.log(`Starting update for ID: ${containerDbId}`);

      vm.$apollo
        .mutate({
          mutation: StartContainerRescrapeFromTerminal,
          variables: { containerId: containerDbId },
        })
        .then(() => {

          let attempts = 0;
          const pollInterval = setInterval(() => {
            attempts++;

            // somehow hit a new error, when re-scrape-updating too many containers at once
            // let's make sure we don't try to query if the vm is not available (esp if component was unmounted while interval is going on)
            if (!vm?.$apollo?.query) {
              return
            }

            vm.$apollo.query({
              query: GetContainerStatus,
              variables: { id: containerDbId },
              fetchPolicy: 'network-only'
            }).then((result) => {

              const remoteContainer = result.data.container;

              if (remoteContainer) {
                const newTime = remoteContainer.lastScraperFetch;
                const newOutcome = remoteContainer.lastScrapeOutcome;

                if (newTime !== initialTime) {
                  clearInterval(pollInterval);

                  // Patch only this row in-place (until the parent's refetch replaces the rows).
                  const rowIndex = vm.rowContainers.findIndex((cntr: any) => cntr.id === containerDbId);
                  if (rowIndex >= 0) {
                    vm.rowContainers.splice(rowIndex, 1, {
                      ...vm.rowContainers[rowIndex],
                      ...remoteContainer,
                      vessel: remoteContainer.vessel || vm.rowContainers[rowIndex].vessel,
                      notes: vm.rowContainers[rowIndex].notes,
                    });
                  }

                  if (vm.loading.includes(containerDbId)) {
                    vm.loading = vm.loading.filter((id) => id !== containerDbId);
                  }
                  const toastMessageAndVariant = vm.getToastScrapeOutcomeMessageAndVariant(newOutcome)
                  pushToast(toastMessageAndVariant.message, toastMessageAndVariant.variant, 6000);
                  vm.scheduleRefreshContainersEmit();
                }
              }
            }).catch(e => console.error(e));

            if (attempts > 20) {
              clearInterval(pollInterval);
              if (vm.loading.includes(containerDbId)) {
                vm.loading = vm.loading.filter((id) => id !== containerDbId);
                pushToast('Update timed out', 'warning');
              }
            }

          }, 3000);

        })
        .catch((err) => {
          if (vm.loading.includes(containerDbId)) {
            vm.loading = vm.loading.filter((id) => id !== containerDbId);
          }
          console.error(err);
          pushToast('Error starting update', 'error');
        });
    },
    archiveContainer(containerIndex: number) {
      const vm = (this as any);

      console.log('emitted event to archive');
      vm.$emit('archiveContainer', containerIndex);
    },
    updateSortBy(val: string) {
      const vm = (this as any);

      vm.$emit('updateSortBy', val);
    },
    containerNotesCount(container: any): number {
      return Array.isArray(container?.notes) ? container.notes.length : 0;
    },
    openContainerNotes(container: any) {
      (this as any).$emit('openContainerNotes', container);
    },
    formatScraperUpdate(timestamp: number | null): string {
      if (!timestamp) return '--';
      const date = new Date(timestamp * 1000);
      return date.toLocaleString('en-US', {
        month: 'numeric',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'America/Los_Angeles'
      }).replace(',', ' ');
    },
    terminalCellClass(terminalValue: string): string {
      const terminal = String(terminalValue || '').toLowerCase();

      if (terminal.includes('ets')) {
        return 'terminal-cell-ets';
      }

      if (terminal.includes('trapac')) {
        return 'terminal-cell-trapac';
      }

      if (terminal.includes('oict')) {
        return 'terminal-cell-oict';
      }

      return '';
    },
    isExportColumnSelected(column: string): boolean {
      return this.isExportSelectionMode && this.selectedColumns[column];
    },
    isExportContainerIdSelected(containerId: string): boolean {
      return this.isExportSelectionMode && this.selectionApi?.isSelected(containerId);
    },
    isExportColumnSelectedForContainerId(column: string, containerId: string,): boolean {
      return this.isExportSelectionMode && this.selectedColumns[column] && this.selectionApi?.isSelected(containerId);
    },
    toggleExportContainer(containerId: string) {
      this.selectionApi?.toggleKey(containerId);
    },
    toggleExportColumn(column: string) {
      if (this.exportSelectionColumnMode === 'single') {
        for (let k of Object.keys(this.selectedColumns)) {
          this.selectedColumns[k] = false;
        }
      }
      this.selectedColumns[column] = !this.selectedColumns[column];
    },
    // Exports the stored value as-is so spreadsheets keep parsing it, but drops
    // the time of day when only the day was entered.
    getExportAppointmentValue(appointmentDate, hasTime): string {
      if (!appointmentDate) return 'N/A';
      if (hasTime === false) {
        return String(appointmentDate).split(/[T ]/)[0];
      }
      return appointmentDate;
    },
    // Same choice as the ETA/LFD cell. No "ETA"/"LFD" prefix, so spreadsheets keep parsing the date.
    getExportEtaOrLfdValue(container): string {
      if (getIsEtaShownForYardStatus(container.yardStatus)) {
        return 'ETA: ' + (container.eta || 'N/A');
      }
      return 'LFD: ' + (container.lfd && container.lfd.length > 2 ? container.lfd : 'N/A');
    },
    getExportReportRow(container): string[] {
      // generate the report row for a single container, only including selected columns
      const selectedColumns = this.selectedColumns;
      // let columns = [];
      return [
        ...(selectedColumns.container ? [container.containerId] : []),
        ...(selectedColumns.bl ? [container.billOfLading?.billOfLadingNumber || 'N/A'] : []),
        ...(selectedColumns.eta ? [this.getExportEtaOrLfdValue(container)] : []),
        ...(selectedColumns.vessel ? [container.vessel?.name || 'N/A'] : []),
        ...(selectedColumns.yardStatus ? [container.yardStatusDescription || 'N/A'] : []),
        ...(selectedColumns.terminal ? [container.terminal || 'N/A'] : []),
        ...(selectedColumns.terminalAppt ? [this.getExportAppointmentValue(container.terminalAppointmentDate, container.terminalAppointmentHasTime)] : []),
        ...(selectedColumns.deliveryAppt ? [this.getExportAppointmentValue(container.deliveryAppointmentDate, container.deliveryAppointmentHasTime)] : []),
        ...(selectedColumns.sizeType ? [container.sizeType || 'N/A'] : []),
        ...(selectedColumns.customer ? [container.customer?.name || 'N/A'] : []),
        ...(selectedColumns.lastTerminalScrapeUpdate ? [this.formatScraperUpdate(container.lastScraperUpdate) || 'N/A'] : []),
        ...(selectedColumns.lastTerminalScrapeFetch ? [this.formatScraperUpdate(container.lastScraperFetch) || 'N/A'] : []),
      ];
    },
    getExportReportHeaders() {
      // add header
      const selectedColumns = this.selectedColumns;
      return [
        ...(selectedColumns.container ? ['Container #'] : []),
        ...(selectedColumns.bl ? ['B/L'] : []),
        ...(selectedColumns.eta ? ['ETA/LFD'] : []),
        ...(selectedColumns.vessel ? ['Vessel'] : []),
        ...(selectedColumns.yardStatus ? ['Yard Status'] : []),
        ...(selectedColumns.terminal ? ['Terminal'] : []),
        ...(selectedColumns.terminalAppt ? ['Terminal Appt'] : []),
        ...(selectedColumns.deliveryAppt ? ['Delivery Appt'] : []),
        ...(selectedColumns.sizeType ? ['Size/Type'] : []),
        ...(selectedColumns.customer ? ['Customer'] : []),
        ...(selectedColumns.lastTerminalScrapeUpdate ? ['Last Scrape Update'] : []),
        ...(selectedColumns.lastTerminalScrapeFetch ? ['Last Scrape'] : []),
      ];
    },
    generateExportReport() {
      if (!this.isExportSelectionMode) {
        return;
      }

      let headers = this.getExportReportHeaders();
      let rows = [];

      for (const container of this.filteredContainers) {
        // skip unselected containers when in select mode
        if (!this.selectionApi?.isSelected(container.id)) {
          continue;
        }

        // add row
        rows.push(this.getExportReportRow(container));
      }
      console.log('rows', rows.length)
      if (this.exportSelectionFormat === 'text') {
        this.exportReportString = this.generateExportReportText(headers, rows);
      } else if (this.exportSelectionFormat === 'csv') {
        this.exportReportString = this.generateExportReportCsv(headers, rows);
      } else if (this.exportSelectionFormat === 'html') {
        this.exportReportString = this.generateExportReportHTML(headers, rows);
      } else {
        this.exportReportString = 'unsupported format'
      }
    },
    generateExportReportText(headers: string[], rows: string[][]): string {
      const headerString = this.isExportReportShowHeader ? headers.join(' ') : '';
      return `${headerString}\n${rows.map(row => row.join(' ')).join("\n")}`;
    },
    generateExportReportCsv(headers: string[], rows: string[][]): string {

      const escapeValueForCsv = (s: string) => {
        console.log('escaping', s);
        const sWithMissingValue = s == null ? 'N/A' : s;
        return `"${(sWithMissingValue).replace(/"/g, '""').replace(/\n\r/g, ' ')}"`
      };

      let escapedHeaderString = ''
      if (this.isExportReportShowHeader) {
        const escapedHeaders = [];
        for (let i = 0; i < headers.length; i++) {
          if (headers[i]) {
            escapedHeaders.push(escapeValueForCsv(headers[i]));
          } else {
            escapedHeaders.push("");
          }
        }
        escapedHeaderString = escapedHeaders.join(',') + '\n';
      }

      const escapedRows: string[] = [];
      for (const row of rows) {
        // replace quotes, commas, and newlines with spaces to avoid breaking csv
        // also replace missing values with "N/A"
        const escapedRow: string[] = [];
        for (let i = 0; i < row.length; i++) {
          if (row[i]) {
            escapedRow.push(escapeValueForCsv(row[i]));
          } else {
            escapedRow.push("");
          }
        }
        escapedRows.push(escapedRow.join(','));
      }

      return escapedHeaderString + escapedRows.join('\n');
    },
    generateExportReportHTML(headers: string[], rows: string[][]): string {
      const headerString = this.isExportReportShowHeader ? `<thead><tr>${headers.map(header => `<th style="border: 1px solid black; padding: 4px; text-align: left;">${header}</th>`).join('')}</tr></thead>` : '';
      return `<table style="border: 1px solid black; border-collapse: collapse;">${headerString}<tbody>${rows.map(row => `<tr>${row.map(cell => `<td style="border: 1px solid black; padding: 4px; text-align: left;">${cell}</td>`).join('')}</tr>`).join('')}</tbody></table>`;
    },
    copyExportReport() {
      if (this.exportSelectionFormat === 'html') {
        // copy to clipboard if possible
        navigator.clipboard.write([
          new ClipboardItem({
            'text/html': new Blob([this.exportReportString], { type: 'text/html' }),
            'text/plain': new Blob([this.exportReportString], { type: 'text/plain' })
          })
        ]).then(() => {
          pushToast('Report copied to clipboard', 'success');
        }).catch((err) => {
          // visually select and tell user to copy
          const tableEl = this.exportReportElementRef.tagName === 'TABLE'
            ? this.exportReportElementRef
            : this.exportReportElementRef.querySelector('table');

          window.getSelection().selectAllChildren(tableEl.parentElement);
          pushToast('Please use CMD+C or Ctrl+C to copy table', 'success');
        });
      } else if (this.exportSelectionFormat === 'text') {
        // copy to clipboard if possible
        navigator.clipboard.write([
          new ClipboardItem({
            'text/plain': new Blob([this.exportReportString], { type: 'text/plain' })
          })
        ]).then(() => {
          pushToast('Report copied to clipboard', 'success');
        }).catch((err) => {
          // visually select and tell user to copy
          const tableEl = this.exportReportElementRef.tagName === 'TABLE'
            ? this.exportReportElementRef
            : this.exportReportElementRef.querySelector('table');

          window.getSelection().selectAllChildren(tableEl.parentElement);
          pushToast('Please use CMD+C or Ctrl+C to copy table', 'success');
        });
      } else if (this.exportSelectionFormat === 'csv') {

        navigator.clipboard.writeText(this.exportReportString)
          .then(() => {
            pushToast('Report copied to clipboard', 'success');
          }).catch((err) => {
            // visually select and tell user to copy
            const el = this.exportReportElementRef;

            window.getSelection().selectAllChildren(el);
            pushToast('Please use CMD+C or Ctrl+C to copy CSV', 'success');
          });
      }

    },
    downloadExportReport() {
      const report = this.exportReportString;
      const fileNamePrefix = 'tracking_export';

      const d = new Date();
      const pad = (n: number) => n.toString().padStart(2, '0');
      const dateTimeString = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}-${pad(d.getHours())}-${pad(d.getMinutes())}-${pad(d.getSeconds())}`;
      const fileName = `${fileNamePrefix}_${dateTimeString}${this.exportSelectionFormat === 'text' ? '.txt' : (this.exportSelectionFormat === 'csv' ? '.csv' : '.html')}`;
      // 1. Create a Blob from the string, specifying the CSV MIME type and UTF-8 encoding
      let blobFormat = this.exportSelectionFormat === 'text' ? 'text/plain;charset=utf-8;' : (this.exportSelectionFormat === 'csv' ? 'text/csv;charset=utf-8;' : 'text/html;charset=utf-8;');

      const blob = new Blob([report], { type: blobFormat });

      // 2. Create a temporary URL pointing to the Blob object
      const url = URL.createObjectURL(blob);

      // 3. Create a hidden anchor (<a>) element to trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';

      // 4. Append to DOM, simulate click, and clean up immediately
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // 5. Free up memory by revoking the object URL
      URL.revokeObjectURL(url);
    },
    resetExportSelectedColumns() {
      this.selectedColumns = this.getExportDefaultColumns();
    },
    setFirstSelectedColumnOnly() {
      let hasSeenFirstSelectedColumn = false;
      for (let k of Object.keys(this.selectedColumns)) {
        if (this.selectedColumns[k] && !hasSeenFirstSelectedColumn) {
          hasSeenFirstSelectedColumn = true;
          continue;
        }
        this.selectedColumns[k] = false;
      }
    },
    getExportDefaultColumns() {
      return {
        container: true,
        bl: true,
        terminalAppt: this.typeOfAppointmentsShowing === 'terminal',
        deliveryAppt: this.typeOfAppointmentsShowing === 'delivery',
        eta: true,
        vessel: !this.typeOfAppointmentsShowing,
        yardStatus: true,
        terminal: true,
        sizeType: true,
        customer: !this.isHideCustomerInfo,
        lastTerminalScrapeUpdate: !this.typeOfAppointmentsShowing,
        lastTerminalScrapeFetch: !this.typeOfAppointmentsShowing,
      }
    },

  },
});
</script>

<style lang="scss" scoped>
/* make table rows mouse cursor "zoom in" to imply "click to view details" */
.table-row td {
  cursor: zoom-in;
  
}

.table-row td.notes-cell {
  cursor: default;
}

.table-shell {
  border-radius: 16px;
}

.table-head th {
  
  position: sticky;
  top: 0;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  z-index: 1;
}

.table-row td.terminal-cell-ets {
  background-color: #9DC284;
}

.table-row td.terminal-cell-trapac {
  background-color: #A9C2F0;
}

.table-row td.terminal-cell-oict {
  background-color: #ffbf49;
}

table.export-report {
  text-align: left;
  border-collapse: collapse;
}

table.export-report th,
table.export-report td {
  border: 1px solid black;
}
</style>
